import SVGInject from '@iconfu/svg-inject'

SVGInject(document.querySelectorAll('img.svg-inject'), {
	makeIdsUnique: false,
})